export const CHOOSE_REGION_PATH = "/choose-region";
